import * as tslib_1 from "tslib";
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectsComponent } from 'src/app/shared/modules/projects/projects.component';
import { EModules } from 'src/app/app.enum';
var CheckinComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CheckinComponent, _super);
    function CheckinComponent(activatedRoute, config) {
        var _this = _super.call(this, activatedRoute, config) || this;
        _this.activatedRoute = activatedRoute;
        _this.config = config;
        (_this.config.company.isEnabledModule(EModules.INBOX)) && _this.setWebSocket();
        return _this;
    }
    return CheckinComponent;
}(ProjectsComponent));
export { CheckinComponent };
